import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import { reportActivity } from '../api';

// Sign-in and account recovery pages are not part of a session.
const NOT_REPORTED = /^\/(auth|login)(\/|$)/;

/**
 * Reports each page a signed-in user moves to, for their Access log trail.
 * Once per change of page, not per render or refresh; the server words it
 * ("Viewed Live map") and ignores pages it does not know. Renders nothing.
 */
export default function ActivityReporter({ enabled }) {
  const { pathname } = useLocation();
  const last = useRef(null);

  useEffect(() => {
    if (!enabled || NOT_REPORTED.test(pathname) || pathname === last.current) return;
    last.current = pathname;
    reportActivity(pathname);
  }, [enabled, pathname]);

  return null;
}

ActivityReporter.propTypes = {
  enabled: PropTypes.bool
};
